import { createSelector } from 'reselect';

const selectBusiness = (state) => state.business;

const selectCategories = createSelector(
	selectBusiness,
	(business) => business?.categories
);

const selectCreateBusiness = createSelector(
	selectBusiness,
	(business) => business?.businessRegister
);

const selectBusinessList = createSelector(
	selectBusiness,
	(state) => state?.list
);
const selectBusinessItem = createSelector(
	selectBusiness,
	(state) => state?.businessItem
);

const businessList = createSelector(
	selectBusiness,
	(state) => state?.businessList
);

const selectUpdatedBusiness = createSelector(
	selectBusiness,
	(state) => state?.updated
);

const selectBusinessContractLink = createSelector(
	selectBusiness,
	(state) => state?.contractLink
);

const selectBusinessContractSign = createSelector(
	selectBusiness,
	(state) => state?.sign
);

const selectBusinessPackages = createSelector(
	selectBusiness,
	(state) => state?.packages
);

const selectSuperBusiness = createSelector(
	selectBusiness,
	(state) => state?.superBusiness
);

const selectContractLinkComplete = createSelector(
	selectBusiness,
	(state) => state?.contractLinkComplete
);

const selectContractBusinessInfo = createSelector(
	selectBusiness,
	(state) => state?.businessInfoContract
);

const selectCashierMachines = createSelector(
	selectBusiness,
	(state) => state?.cashierMachines
);
const selectShowOffcbReport = createSelector(
	selectBusiness,
	(state) => state?.showOffcbReport
);
const selectShowCoreReport = createSelector(
	selectBusiness,
	(state) => state?.showCoreReport
);

const businessSelectors = {
	selectBusiness,
	selectCategories,
	selectBusinessList,
	selectUpdatedBusiness,
	selectBusinessContractLink,
	selectBusinessPackages,
	selectBusinessContractSign,
	selectSuperBusiness,
	selectContractLinkComplete,
	selectContractBusinessInfo,
	selectCreateBusiness,
	selectCashierMachines,
	selectShowOffcbReport,
	selectShowCoreReport,
	businessList,
	selectBusinessItem,
};

export default businessSelectors;
